// @flow
import * as React from 'react';
import { Divider, Stack } from '@mui/material';
import { ContactInfo } from './contact-info';
import { ClientGroups } from './client-groups';
import { ChannelAttribution } from './channel-attribution';

export const ClientPersonal = () => {

  return (
    <Stack gap={2}>
      <ContactInfo />
      <Divider />
      <ClientGroups />
      <Divider />
      <ChannelAttribution />
    </Stack>
  );
};

